// extracted by mini-css-extract-plugin
export var hidden = "_tp-0";